import React from 'react';

const LaneMatrixView = ({ competitions, runningOrder, formatAnnouncedPerformance, formatTimeHHMM, t }) => {
  const roComp = (competitions || []).find(c => c.id === runningOrder?.session?.competition_id);
  const laneCount = parseInt(roComp?.lanes) || 4;
  const passages = [...runningOrder.running_order].sort((a, b) => (a.passage_order || 0) - (b.passage_order || 0));
  const lanes = Array.from({ length: laneCount }, (_, i) => ({ lane: i + 1, athletes: passages.filter((_, idx) => idx % laneCount === i) }));
  const statusColor = (s) => s === 'completed' ? 'border-green-500/50 bg-green-900/20' : (s === 'active' || s === 'performing') ? 'border-yellow-400/70 bg-yellow-900/30' : 'border-blue-700/30 bg-blue-800/20';

  return (
    <div className="p-3" data-testid="lane-matrix-view">
      <div className="grid gap-2" style={{ gridTemplateColumns: `repeat(${Math.min(laneCount, 6)}, 1fr)` }}>
        {lanes.map(({ lane }) => (
          <div key={`h-${lane}`} className="text-center py-2 bg-blue-800/40 rounded-t-lg border border-blue-700/50 text-teal-300 font-bold text-sm">
            {t('lane') || 'Lane'} {lane}
          </div>
        ))}
        {lanes.map(({ lane, athletes }) => (
          <div key={`c-${lane}`} className="space-y-1">
            {athletes.map((p) => {
              const fd = p.registration?.freediver || {};
              return (
                <div key={p.id} className={`rounded-lg border p-2 ${statusColor(p.status)}`}>
                  <div className="flex items-center justify-between mb-1">
                    <span className="text-xs text-blue-400 font-mono">#{p.passage_order}</span>
                    <span className="text-xs text-teal-400 font-semibold">{formatAnnouncedPerformance(p)}</span>
                  </div>
                  <div className="text-white text-sm font-semibold truncate">{(fd.last_name || '').toUpperCase()}</div>
                  <div className="text-blue-300 text-xs truncate">{fd.first_name || '-'}</div>
                  <div className="flex items-center justify-between mt-1">
                    <span className="text-xs text-blue-400">{fd.nationality || ''}</span>
                    <span className="text-xs font-mono text-yellow-300">{formatTimeHHMM(p.official_top_time)}</span>
                  </div>
                </div>
              );
            })}
          </div>
        ))}
      </div>
    </div>
  );
};

export default LaneMatrixView;
